import { NgFor } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { MarketplaceLogoComponent } from "../../../components/marketplace-logo/market-place-logo.component";
import { TypedAppConfigService } from "../../../services/typed-app.config.service";
@Component({
	selector: "app-landing-page-footer",
	styleUrls: ["./landing-page-shared.scss", "./landing-page-footer.component.scss"],
	template: `
		<div class="footer__background-wrapper">
			<footer class="footer">
				<h2 class="cdk-visually-hidden">{{ "landing.footer.links" | translate }}</h2>
				<ul class="footer__inner">
					<li class="footer__column" aria-label="Marketplace Logo">
						<app-marketplace-logo
							width="54px"
							height="54px"
							minWidth="54px"
							minHeight="54px"
						/>
					</li>
					<li class="footer__column">
						<div class="footer__column-header">
							{{ "landing.footer.about" | translate }}
						</div>
						<ul class="footer__column">
							<li>
								<a href="https://www.bluestaq.com">Bluestaq</a>
							</li>
						</ul>
					</li>
					<li class="footer__column">
						<div class="footer__column-header">
							{{ "landing.footer.legal" | translate }}
						</div>
						<ul class="footer__column">
							<li *ngFor="let agreement of agreements">
								<a
									href="{{ agreement.URL }}"
									target="blank"
									rel="noopener noreferrer"
									>{{ agreement.NAME }}</a
								>
							</li>
						</ul>
					</li>
					<li class="footer__column">
						<div class="footer__column-header">
							{{ "landing.footer.learn" | translate }}
						</div>
						<ul class="footer__column">
							<li>
								<a href="https://unifieddatalibrary.com/">UDL</a>
							</li>
							<!-- <li>
                                <a routerLink="/app/FAQ">FAQ</a>
                            </li> -->
						</ul>
					</li>
				</ul>
				<hr class="divider divider--dark" />
				<p class="footer__terms-text">
					{{ "landing.footer.terms-of-use" | translate }}
				</p>
			</footer>
		</div>
	`,
	imports: [MarketplaceLogoComponent, NgFor, TranslatePipe]
})
export class LandingPageFooterComponent {
	agreements;

	constructor(private appConfigService: TypedAppConfigService) {
		this.agreements = this.appConfigService.getConfigValue("AGREEMENTS") || [];
	}
}
